import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const Homepage: React.FC = () => {
    const navigate = useNavigate();
    const [inputValue, setInputValue] = useState<number>(() => {
        const saved = sessionStorage.getItem('timerInterval');
        return saved ? parseInt(saved) : 5;
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value) || 5;
        setInputValue(newValue);
        sessionStorage.setItem('timerInterval', newValue.toString());
    };

    const handleSubmit = (event: React.SubmitEvent) => {
        event.preventDefault();

        navigate(`/timer?interval=${inputValue}`);
    };

    return (
        <form className="Homepage" onSubmit={handleSubmit}>
            <label>
                Timer:
                <input
                    className="InputField"
                    type="number"
                    value={inputValue}
                    onChange={handleChange}
                    min="1"
                    max="999999"
                />
                seconds
            </label>
            <br/>
            <button className="SubmitButton" type="submit">
                Submit
            </button>
        </form>
    );
};
